import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3938af53"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fin entrega de listas:", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Inicio de inscripción:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fin de inscripción:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Plazas restantes:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Pagos:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Listas entregadas:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Listas legales:", -1))
const _hoisted_8 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_9 = { style: {"text-align":"center","font-size":"12px","margin-top":"4px"} }

import { Torneo } from "@/interfaces/Torneo";
import { computed, ref, watch } from "vue";
import { getListasTorneoAsync, getTorneo } from "@/services/TorneosService";
import ModalModificarBasesTorneo from "../ModalModificarBasesTorneo.vue";
import ModalModificarTorneo from "../ModalModificarTorneo.vue";
import { TorneoEquipoGestionInfoDTO } from "@/interfaces/Inscripcion";
import ModalHandlerMostrarListas from "../ModalHandlerMostrarListas.vue";
import ModalHandlerMostrarClasificacion from "../ModalHandlerMostrarClasificacion.vue";
import CardAddTorneoCircuito from "../CardAddTorneoCircuito.vue";
import { ClassificationType } from "@/Constant/TipoClasificacion";
import LoadingLOTR from "@/components/Commons/LoadingLOTR.vue";
import ModalError from "@/components/Commons/ModalError.vue";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import { ListaCompletaDTO } from "@/interfaces/Lista";
import jsPDF from "jspdf";
import { descargarListasPDF } from "@/utils/descargarListas";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'CardGestionInfoTorneoEquipo',
  props: {
    torneo: {}
  },
  setup(__props: any) {

const props = __props;
const showErrorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const showModificarTorneoModal = ref<boolean>(false);
const showModificarBasesTorneoModal = ref<boolean>(false);
const showModalHandlerMostrarListas = ref<boolean>(false);
const showModalHandlerMostrarClasificacion = ref<boolean>(false);

const mostrarClasificacion = ref(props.torneo?.torneo.mostrarClasificacion);
const mostrarListas = ref(props.torneo?.torneo.mostrarListas);

const progressPDF = ref<number>(0);

watch(
  () => props.torneo?.torneo.mostrarListas,
  nuevoValor => {
    mostrarListas.value = nuevoValor;
  }
);

watch(
  () => props.torneo?.torneo.mostrarClasificacion,
  nuevoValor => {
    mostrarClasificacion.value = nuevoValor;
  }
);

const idTorneo = ref<number>(0);
const isLoading = ref<boolean>(false);
const isDownloading = ref<boolean>(false);
const torneoMod = ref<Torneo>({
  idTorneo: 0,
  idUsuario: 0,
  nombreTorneo: "",
  descripcionTorneo: "",
  fechaInicioTorneo: "",
  fechaFinTorneo: "",
  precioTorneo: 0,
  numeroPartidas: 0,
  puntosTorneo: 0,
  estadoTorneo: "ESPERANDO",
  lugarTorneo: "",
  tipoTorneo: "Individual",
  esPrivadoTorneo: false,
  idRangoTorneo: 0,
  esMatchedPlayTorneo: false,
  fechaEntregaListas: "",
  fechaFinInscripcion: "",
  basesTorneo: "",
  cartelTorneo: "",
  metodosPago: [],
  horaInicioTorneo: "",
  horaFinTorneo: "",
  tieneBases: false,
  inicioInscripciones: "",
  listasPorJugador: 0,
  mostrarListas: false,
  mostrarClasificacion: false,
  classificationType: ClassificationType.NORMAL,
});

const plazasRestantes = computed(() => {
  if (!props.torneo || props.torneo.torneo.limiteParticipantes === null) {
    return "Sin límite";
  }
  if (props.torneo.torneo.limiteParticipantes) {
    return props.torneo.torneo.limiteParticipantes - totalEquipos.value;
  }
  return "Sin límite";
});

const totalEquipos = computed(() => {
  return props.torneo ? props.torneo.equipos.length : 0;
});

const jugadoresXEquipo = computed(() => {
  return props.torneo ? props.torneo.torneo.jugadoresXEquipo : 0;
});

const totalJugadores = computed(() => {
  return totalEquipos.value * jugadoresXEquipo.value;
});

const esParejas = computed(() => props.torneo?.torneo.tipoTorneo === "Parejas");
// Con lista conjunta cada pareja entrega una sola lista, aunque marque entregada a los dos
const esListaConjunta = computed(
  () => esParejas.value && props.torneo?.torneo.listaPorPareja === true
);

const totalListas = computed(() =>
  esListaConjunta.value ? totalEquipos.value : totalJugadores.value
);

const pagosRealizados = computed(() => {
  if (!props.torneo) return 0;
  return props.torneo.equipos.filter(equipo => equipo.esPago === "SI").length;
});

const listasLegales = computed(() => {
  if (!props.torneo) return 0;
  return props.torneo.equipos.reduce((contador, equipo) => {
    // Para cada equipo, contamos cuántas inscripciones cumplen con los estados
    const listas = equipo.inscripciones.filter(
      lista => lista.estadoLista === "OK"
    ).length;

    if (esListaConjunta.value) return contador + (listas > 0 ? 1 : 0);

    // Sumamos el número de listas válidas al contador
    return contador + listas;
  }, 0);
});

const listasEntregadas = computed(() => {
  if (!props.torneo) return 0;

  return props.torneo.equipos.reduce((contador, equipo) => {
    // Para cada equipo, contamos cuántas inscripciones cumplen con los estados
    const listas = equipo.inscripciones.filter(
      lista =>
        lista.estadoLista === "OK" ||
        lista.estadoLista === "ENTREGADA" ||
        lista.estadoLista === "ILEGAL"
    ).length;

    if (esListaConjunta.value) return contador + (listas > 0 ? 1 : 0);

    // Sumamos el número de listas válidas al contador
    return contador + listas;
  }, 0);
});

const formatDate = (date: string | null | undefined) => {
  if (!date) return "N/A";
  return new Date(date).toLocaleDateString();
};

const modificarTorneo = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneoMod.value = responseTorneo.data;
    showModificarTorneoModal.value = true;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
    showErrorModal.value = false;
  }
};

const modificarBasesTorneo = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneoMod.value = responseTorneo.data;
    showModificarBasesTorneoModal.value = true;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
    showErrorModal.value = false;
  }
};

const handlerMostrarListas = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneoMod.value = responseTorneo.data;
    showModalHandlerMostrarListas.value = true;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
    showErrorModal.value = false;
  }
};

const handlerMostrarClasificacion = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneoMod.value = responseTorneo.data;
    showModalHandlerMostrarClasificacion.value = true;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
    showErrorModal.value = false;
  }
};

function chunkArray<T>(arr: T[], size: number): T[][] {
  const result: T[][] = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
}

const descargarListasTorneo = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    isDownloading.value = true;
    const response = await getListasTorneoAsync(idTorneo.value);
    const listas: ListaCompletaDTO[] = response.data;
    await descargarListasPDF(
      listas,
      props.torneo?.torneo.nombreTorneo ?? "",
      jugadoresXEquipo.value,
      (current, total) => { progressPDF.value = Math.round((current / total) * 100); }
    );
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    progressPDF.value = 0;
    isDownloading.value = false;
    showErrorModal.value = false;
  }
};

const cerrarModal = async () => {
  showModificarBasesTorneoModal.value = false;
  showModalHandlerMostrarListas.value = false;
  showModalHandlerMostrarClasificacion.value = false;

  showModificarTorneoModal.value = false;
};

const onCambioMostrarListas = (nuevoValor: boolean) => {
  mostrarListas.value = nuevoValor;
  showModalHandlerMostrarListas.value = false;
};

const onCambioMostrarClasificacion = (nuevoValor: boolean) => {
  mostrarClasificacion.value = nuevoValor;
  showModalHandlerMostrarClasificacion.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.torneo)
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 0,
          class: "mb-4 pa-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h6 font-weight-bold align-center" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.torneo.torneo.nombreTorneo), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider, { class: "mt-3" }),
            _createVNode(_component_v_card_text, { class: "text-body-2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { dense: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6",
                      class: "d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "me-2",
                          color: "blue"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-calendar-clock")
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", null, [
                          _hoisted_1,
                          _createTextVNode(" " + _toDisplayString(formatDate(_ctx.torneo.torneo.fechaEntregaListas)), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6",
                      class: "d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "me-2",
                          color: "green"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-calendar-plus")
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", null, [
                          _hoisted_2,
                          _createTextVNode(" " + _toDisplayString(formatDate(_ctx.torneo.torneo.inicioInscripciones)), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6",
                      class: "d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "me-2",
                          color: "red"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-calendar-remove")
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", null, [
                          _hoisted_3,
                          _createTextVNode(" " + _toDisplayString(formatDate(_ctx.torneo.torneo.fechaFinInscripcion)), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6",
                      class: "d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "me-2",
                          color: "yellow"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-account-group")
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", null, [
                          _createElementVNode("strong", null, _toDisplayString(esParejas.value ? "Parejas inscritas:" : "Equipos inscritos:"), 1),
                          _createTextVNode(" " + _toDisplayString(totalEquipos.value), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6",
                      class: "d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "me-2",
                          color: "orange"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-seat-outline")
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", null, [
                          _hoisted_4,
                          _createTextVNode(" " + _toDisplayString(plazasRestantes.value), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6",
                      class: "d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "me-2",
                          color: "green"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-cash-multiple")
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", null, [
                          _hoisted_5,
                          _createTextVNode(" " + _toDisplayString(pagosRealizados.value) + "/" + _toDisplayString(totalEquipos.value), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6",
                      class: "d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "me-2",
                          color: "blue"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-file-document")
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", null, [
                          _hoisted_6,
                          _createTextVNode(" " + _toDisplayString(listasEntregadas.value) + "/" + _toDisplayString(totalListas.value), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6",
                      class: "d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "me-2",
                          color: "purple"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-file-check")
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", null, [
                          _hoisted_7,
                          _createTextVNode(" " + _toDisplayString(listasLegales.value) + "/" + _toDisplayString(totalListas.value), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider, { class: "my-2" }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "secondary",
                          onClick: modificarTorneo,
                          block: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Modificar torneo")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "secondary",
                          onClick: modificarBasesTorneo,
                          block: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Modificar bases")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "secondary",
                          onClick: handlerMostrarListas,
                          block: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(mostrarListas.value ? "Ocultar" : "Mostrar") + " Listas", 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "secondary",
                          onClick: handlerMostrarClasificacion,
                          block: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(mostrarClasificacion.value ? "Ocultar" : "Mostrar") + " Clasificación", 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "secondary",
                          onClick: descargarListasTorneo,
                          block: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Descargar Listas")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _renderSlot(_ctx.$slots, "acciones")
                  ]),
                  _: 3
                })
              ]),
              _: 3
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(CardAddTorneoCircuito, {
                  idTorneo: props.torneo?.torneo.idTorneo!
                }, null, 8, ["idTorneo"])
              ]),
              _: 1
            })
          ]),
          _: 3
        }))
      : _createCommentVNode("", true),
    _createVNode(ModalModificarTorneo, {
      isVisible: showModificarTorneoModal.value,
      torneo: torneoMod.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (cerrarModal()))
    }, null, 8, ["isVisible", "torneo"]),
    _createVNode(ModalModificarBasesTorneo, {
      isVisible: showModificarBasesTorneoModal.value,
      torneo: torneoMod.value,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (cerrarModal()))
    }, null, 8, ["isVisible", "torneo"]),
    _createVNode(ModalHandlerMostrarListas, {
      isVisible: showModalHandlerMostrarListas.value,
      torneo: torneoMod.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (cerrarModal())),
      onConfirm: onCambioMostrarListas
    }, null, 8, ["isVisible", "torneo"]),
    _createVNode(ModalHandlerMostrarClasificacion, {
      isVisible: showModalHandlerMostrarClasificacion.value,
      torneo: torneoMod.value,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (cerrarModal())),
      onConfirm: onCambioMostrarClasificacion
    }, null, 8, ["isVisible", "torneo"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Torneo modificado con éxito.",
      "onUpdate:isVisible": _cache[4] || (_cache[4] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se han podido modificar el torneo. Intentalo de nuevo y si el error persiste contacta con el administrador.",
      "onUpdate:isVisible": _cache[5] || (_cache[5] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(LoadingLOTR, {
      isVisible: isDownloading.value,
      mensaje: "Generando PDF, por favor espera..."
    }, {
      default: _withCtx(() => [
        (isDownloading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(progressPDF.value) + "% ", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["isVisible"])
  ], 64))
}
}

})